/**
 * Adds support for confirm dialogs defined by data-confirm and optionally by data-confirm-title.
 * This is global initializer, it is initialized only on page load, not subsequently.
 *
 * Usage:
 * <a href="/api/DeleteProduct/5" data-confirm="Common:ConfirmProductDelete" data-confirm-title="Common:ConfirmDeleteTitle">Delete product</a>
 */

import $ from 'jquery';
import message from '../message';

export default function () {
		$(this).find('a[data-confirm], button[data-confirm]').click(function () {
			const $a = $(this);
			const confirmed = $a.data('confirmed');
			if (!confirmed) {
				message.confirm(
						$a.attr('data-confirm'),
						$a.attr('data-confirm-title')
				).then(function() {
					$a.data('confirmed', true);
					setTimeout(function () {
						$a.get(0).click();
					}, 0);
				}).catch(function(){});
				return false;
			} else {
				$a.data('confirmed', false);
			}
			return true;
		});
};


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/confirm.js